import React from 'react';
import PropTypes from 'prop-types';
import { getPriceByAmount } from 'utils/tokens';

import './style.css';

const PricingCard = ({ title, description, amount, children, onClick }) => {
  return (
    <article className="pricing-card">
      <div className="pricing-card-wrapper">
        <h2 className="pricing-card-title">{title}</h2>
        {children}
        <button className="pricing-card-button" type="button" onClick={onClick}>
          <span className="pricing-card-amount">
            {amount} / £{getPriceByAmount(amount)}
          </span>
        </button>
        <div className="pricing-card-description">{description}</div>
      </div>
    </article>
  );
};

PricingCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
};

PricingCard.defaultProps = {
  children: null,
};

export default PricingCard;
